import { Clock, UserRound } from "lucide-react";

export function HomeHeroIllustration() {
  return (
    <div className="home-hero-stack" aria-hidden="true">
      <div className="home-hero-orbit" />
      <div className="home-hero-card home-hero-card--low">
        <div className="home-hero-card-heading"><span className="home-hero-check" /><i /><span className="home-priority home-priority--low">Baja</span></div>
      </div>
      <div className="home-hero-card home-hero-card--medium">
        <div className="home-hero-card-heading"><span className="home-hero-check" /><i /><span className="home-priority home-priority--medium">Media</span></div>
        <div className="home-hero-lines"><i /><i /></div>
      </div>
      <div className="home-hero-card home-hero-card--high">
        <div className="home-hero-card-heading"><span className="home-hero-check" /><span>Revisar tarea</span><span className="home-priority home-priority--high">Alta</span></div>
        <div className="home-hero-lines"><i /><i /></div>
        <div className="home-hero-card-footer"><UserRound size={17} /><i /><Clock size={17} /><i /></div>
      </div>
    </div>
  );
}
